import { ObserverItem } from "@core/libs/observer";

export {};

document.addEventListener('started', () => {
    if (typeof Splide === 'undefined') {
        return;
    }
    
    mountSubmenuSlide();
    mountOtherSliders();
});

function mountSubmenuSlide(): void {
    app.html.qAll('.submenu.splide')
        .forEach(splideEl => {
            const splide = new Splide(splideEl);

            // Scroll splide to the selected item
            splide.on('mounted', () => {
                app.html.removeClass(splideEl, 'hidden');

                const i = app.html.qAll('.splide__slide', splideEl)
                    .findIndex(slide => app.html.hasClass(slide,'selected'));

                if (i > -1) {
                    splide.go(i);
                }
            });

            splide.mount();
        });
}

function mountOtherSliders(): void {
    // Loop through all splides and mount() them. 
    app.html.qAll('.splide')
        .filter(el => !el.classList.contains('splide-no-auto-mount'))
        .forEach((splideEl: HTMLElement, i: number) => {
            new Splide(splideEl).mount();
        });
}

function mountVoyoSplide(item: ObserverItem): void {
    const splideEl = item.element as HTMLElement;
    new Splide(splideEl).mount();
}

function goBack() {
    history.back();
}

// Plays a 5ka video in place using the full category player (seasons, episode
// slider, "Prikaži več", prev/next) — the same overlay the category page uses.
function playVoyoVideo(mediaId: string, url: string, forAVOD: string = ''): void {
    if (!window.app) {
        return;
    }

    if (!app.user.loginGuard()) {
        return;
    }

    if (!app.user.user?.isSubscribed) {
        document.location.href = config.routes.activation;
        return;
    }

    if (app.playRestriction.restrictAppPlayback()) {
        return;
    }

    app.voyoVideo.stopVideoPlayers();
    app.html.addClass('body', 'playing_content');

    window.playEpisode?.(mediaId, url, forAVOD);
}

// Stop players when leaving the page.
window.addEventListener('beforeunload', () => {
    if (window.app) {
        app.voyoVideo.stopVideoPlayers();
    }
});

window.goBack = goBack;
window.mountVoyoSplide = mountVoyoSplide;
window.playVoyoVideo = playVoyoVideo;
